import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import { Authenticator } from "@aws-amplify/ui-react";

// Import React Query
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

Amplify.configure(awsconfig);

// Create a client
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Authenticator.Provider>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </Authenticator.Provider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
